<template>
  <w-layout>
    <w-layout-sidebar v-if="!hideSidebar">
      <w-stack
        direction="column"
        justify-content="space-between"
        align-items="center"
        full-height
        full-width
      >
        <w-stack
          direction="column"
          gap="small"
          align-items="center"
          justify-content="center"
          full-width
        >
          <docplanner-logo
            style="cursor: pointer"
            @click="handleReturnToHome"
          />
          <w-stack
            direction="column"
            gap="small"
            full-width
            justify-content="center"
            align-items="center"
          >
            <slot name="items" />
          </w-stack>
        </w-stack>
        <div
          class="cursor-pointer"
          @click="handleAvatarClick"
        >
          <w-popover
            :v-model="showLogout"
            position="right"
          >
            <w-avatar
              :inverted="true"
              variant="user"
            />

            <template #content>
              <w-spacer horizontal="small">
                <w-stack
                  direction="column"
                  gap="small"
                >
                  <w-button
                    variant="plain"
                    leading-icon="logout"
                    data-test-id="logout-button"
                    :label="$t('logout')"
                    @click="handleLogout"
                  />
                </w-stack>
              </w-spacer>
            </template>
          </w-popover>
        </div>
      </w-stack>
    </w-layout-sidebar>
    <w-layout-main>
      <w-spacer
        top="xlarge"
        bottom="large"
        horizontal="small"
      >
        <w-spacer bottom="small">
          <bread-crumb v-if="showBreadcrumbs" />
        </w-spacer>
        <router-view />
      </w-spacer>
    </w-layout-main>
  </w-layout>
</template>

<script setup lang="ts">
import {
  WAvatar,
  WButton,
  WLayout,
  WLayoutMain,
  WLayoutSidebar,
  WPopover,
  WSpacer,
  WStack,
} from '@dp-watson-web/components';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import { useLoginFlowPlugin } from '@/plugins/login-flow';
import { RouteNames } from '@/router/routeNames';
import BreadCrumb from '@/shared/layouts/base/components/BreadCrumb.vue';
import DocplannerLogo from '@/shared/layouts/base/components/DocplannerLogo.vue';
import { useRouterBreadcrumb, useRouterLayout } from '@/shared/layouts/base/composables';

const router = useRouter();
const loginFlow = useLoginFlowPlugin();
const showLogout = ref(false);

const handleReturnToHome = () => {
  router.push({ name: RouteNames.HOME });
};

const handleAvatarClick = () => {
  showLogout.value = !showLogout.value;
};

const handleLogout = () => {
  showLogout.value = false;
  loginFlow.logout();
};

const { hideSidebar } = useRouterLayout();
const { showBreadcrumbs } = useRouterBreadcrumb();
</script>

<style scoped></style>
